module.exports = __webpack_public_path__ + "img/vimeo.33d39012.png";